// Serviceable Pincodes Data extracted from Wiom_Prelaunch_Pincode_Serviceability_Master.xlsx
// This list contains all pincodes where Wiom will be available by 26th January 2026

export const SERVICEABLE_PINCODES = new Set([
  // Delhi
  "110001", "110002", "110003", "110005", "110006", "110007", "110008", "110009", "110010",
  "110011", "110012", "110013", "110014", "110015", "110016", "110017", "110018", "110019", "110020",
  "110021", "110022", "110023", "110024", "110025", "110026", "110027", "110028", "110029", "110030",
  "110031", "110032", "110033", "110034", "110035", "110036", "110037", "110038", "110039", "110040",
  "110041", "110042", "110043", "110044", "110045", "110046", "110047", "110048", "110049", "110051",
  "110052", "110053", "110054", "110055", "110056", "110057", "110058", "110059", "110060", "110061",
  "110062", "110063", "110064", "110065", "110066", "110067", "110068", "110069", "110070", "110071",
  "110072", "110073", "110074", "110075", "110076", "110077", "110078", "110080", "110081", "110082",
  "110083", "110084", "110085", "110086", "110087", "110088", "110089", "110090", "110091", "110092",
  "110093", "110094", "110095", "110096",
  // Gurugram, Haryana
  "122001", "122002", "122003", "122004", "122006", "122007", "122008", "122009", "122010",
  "122011", "122015", "122016", "122017", "122018", "122051",
  // Noida, UP
  "201301", "201302", "201303", "201304", "201305", "201306", "201307", "201308", "201309",
  // Greater Noida, UP
  "201310", "201318", "203201",
  // Faridabad, Haryana
  "121001", "121002", "121003", "121004", "121005", "121006", "121007",
  // Ghaziabad, UP
  "201001", "201002", "201003", "201004", "201005", "201009",
  // Meerut, Uttar Pradesh
  "250001", "250002", "250003", "250004", "250005",
  // Bijnor, Uttar Pradesh
  "246701", "246702", "246721",
  // Muzaffarnagar, Uttar Pradesh
  "251001", "251002", "251003", "251004",
  // Hapur, Uttar Pradesh
  "245101", "245304",
  // Modinagar, Uttar Pradesh
  "201204",
  // Agra, Uttar Pradesh
  "282001", "282002", "282003", "282004", "282005", "282006", "282007", "282008", "282009", "282010",
  // Aligarh, Uttar Pradesh
  "202001", "202002",
  // Mathura, Uttar Pradesh
  "281001", "281002", "281003", "281004",
  // Firozabad, Uttar Pradesh
  "283203", "283204", "283205",
  // Shikohabad, Uttar Pradesh
  "283135",
  // Bareilly, Uttar Pradesh
  "243001", "243002", "243003", "243004", "243005", "243006",
  // Moradabad, Uttar Pradesh
  "244001", "244002", "244003",
  // Budaun, Uttar Pradesh
  "243601", "243602",
  // Lucknow, Uttar Pradesh
  "226001", "226002", "226003", "226004", "226005", "226006", "226007", "226008", "226009", "226010",
  "226011", "226012", "226013", "226014", "226015", "226016", "226017", "226018", "226019", "226020",
  "226021", "226022", "226023", "226024", "226025", "226026", "226027", "226028", "226029", "226030",
  // Prayagraj, Uttar Pradesh
  "211001", "211002", "211003", "211004", "211005", "211006", "211007", "211008", "211009", "211010",
  "211011", "211012",
  // Gorakhpur, Uttar Pradesh
  "273001", "273002", "273003", "273004", "273005", "273006", "273007", "273008", "273009", "273010",
  // Uttar Pradesh – additional districts (Agra, Aligarh, Ambedkar Nagar, Amethi, Amroha, Auraiya, Ayodhya, Azamgarh, Baghpat, Bahraich, Ballia, Balrampur, Banda, Barabanki, Bareilly, Basti, Bhadohi, Bijnor, Budaun, Bulandshahr, Chandauli, Chitrakoot, Deoria, Etah, Etawah, Farrukhabad, Fatehpur, Firozabad, Gautam Buddha Nagar, Ghaziabad, Ghazipur, Gonda, Hamirpur, Hardoi, Hathras, Jalaun, Jaunpur, Jhansi, Kannauj, Kanpur Dehat, Kanpur Nagar, Kasganj, Kaushambi, Kushinagar, Lakhimpur Kheri, Lalitpur, Lucknow, Maharajganj, Mahoba, Mainpuri, Mathura, Mau, Meerut, Mirzapur, Moradabad, Muzaffarnagar, Pilibhit, Pratapgarh, Raebareli, Rampur, Saharanpur, Sant Kabir Nagar, Shahjahanpur, Shamli, Shravasti, Siddharthnagar, Sitapur, Sonbhadra, Sultanpur, Unnao, Varanasi)
  "202124", "204101", "204216", "203301", "202280", "202137", "224122", "224149", "224190",
  "227405", "229301", "229302", "244221", "244223", "244241", "206122", "206243", "224001", "224229",
  "276001", "276202", "276305", "275101", "250609", "250611", "250101", "271801", "271865", "271903",
  "277001", "277211", "277205", "271201", "271308", "210001", "210201", "210431", "225001", "225301", "225119",
  "243503", "243301", "243201", "272001", "272175", "272155", "221401", "221304", "246762", "246725", "246763",
  "202520", "203001", "203131", "203396", "203205", "232101", "210204", "210205", "274408", "207001", "207123", "207403",
  "206001", "206242", "209601", "209625", "212601", "212635", "283101", "205135", "283204", "203207", "201102", "201012", "201014",
  "233001", "233306", "271209", "274304", "210301", "241001", "241124", "241204", "281306", "285001", "285205", "285204",
  "222001", "222129", "284204", "209701", "209101", "209304", "208017", "208020", "208011", "212217", "212208",
  "274400", "274201", "262802", "284403", "273153", "273164", "210427", "205001", "281121", "281502", "281403", "281401",
  "275301", "245205", "250401", "231001", "231304", "231307", "244302", "244401", "247771", "247121", "251309", "251201",
  "262001", "262122", "230001", "229202", "229001", "244901", "244602", "247341", "247554", "272271", "242001", "242307",
  "271831", "271879", "272208", "272153", "261001", "261203", "231206", "231216", "228001", "209801", "209401", "221001", "221002", "221003", "221005", "221007", "221010",
  // Maharashtra – Mumbai
  "400001", "400002", "400003", "400004", "400005", "400006", "400007", "400008", "400009", "400010",
  "400011", "400012", "400013", "400015", "400016", "400017", "400018", "400019", "400020", "400021",
  "400022", "400023", "400024", "400025", "400026", "400029", "400030", "400031", "400032", "400033",
  "400034", "400036", "400042", "400043", "400049", "400050", "400051", "400052", "400054", "400055",
  "400056", "400057", "400058", "400059", "400060", "400061", "400062", "400063", "400064", "400065",
  "400066", "400067", "400068", "400070", "400071", "400072", "400074", "400075", "400076", "400077",
  "400078", "400079", "400080", "400081", "400083", "400084", "400088", "400089", "400091", "400093",
  "400096", "400097", "400099", "400101", "400102",
  // Maharashtra – Navi Mumbai
  "400701", "400702", "400703", "400705", "400706", "400708", "400709", "400614", "410210", "410209", "410206",
  // Maharashtra – Thane
  "400601", "400602", "400603", "400604", "400605", "400607", "400610", "400612", "400615", "421302", "421001",
  "421501", "421503", "421605", "421301", "421201", "401107", "401101", "401201", "401303"
]);

// Function to check if a pincode is serviceable
export const isPincodeServiceable = (pincode) => {
  return SERVICEABLE_PINCODES.has(pincode?.toString().trim());
};

